module.exports = __webpack_public_path__ + "img/online-streaming.9275a34b.svg";